import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import {
  nextStep,
  prevStep,
  addStepsData,
} from "app/lib/store/slices/steps/loanTypesSteps";
import { RootState } from "app/lib/store/store";
import { useDispatch } from "react-redux";
import MainTitle from "app/components/common/typography/MainTitle";
import ContinueButton from "app/components/common/buttons/Continue";
import PreviousButtom from "app/components/common/buttons/Previous";
import ProgressBar from "app/components/common/progressbar/ProgressBar";
import RadioButton from "app/components/common/buttons/RadioButton";
import SubTitle from "app/components/common/typography/SubTitle";
import ErrorsMessage from "app/components/common/errors/ErrorsMessage";

interface FormData {
  purchaseFrom: string;
  vehicleCondition: string;
}

const ConditionAndPurchase: React.FC = () => {
  const dispatch = useDispatch();
  const { vehicleDetail, ...remaingData } = useSelector(
    (state: RootState) => state.loanTypesSteps.stepsData
  );

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<FormData>();

  const onSubmit = (data: FormData) => {
    const { vehicleCondition, purchaseFrom } = data;
    dispatch(
      addStepsData({
        ...remaingData,
        vehicleDetail: {
          ...vehicleDetail,
          vehicleCondition,
          purchaseFrom,
        },
      })
    );
    dispatch(nextStep());
  };

  useEffect(() => {
    if (vehicleDetail) {
      reset({
        purchaseFrom: vehicleDetail.purchaseFrom || "",
        vehicleCondition: vehicleDetail.vehicleCondition || "",
      });
    }
  }, [vehicleDetail, reset]);

  return (
    <>
      <ProgressBar progress={10} />
      <div className="w-full  sm:w-[70%] xl:w-[40%]  mx-auto text-center px-4 sm:px-0">
        <MainTitle title="Condition & Purchase" />
        <SubTitle title="Tell us about your vehicle and how you're acquiring it" />

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="text-left mb-5">
            <h6 className="font-Mulish text-nowrap text-base text-lightBlue mb-4">
              How are you acquiring the vehicle?
            </h6>
            <div className="flex gap-5">
              <Controller
                name="purchaseFrom"
                control={control}
                rules={{ required: "Please select an option" }}
                render={({ field: { value, onChange } }) => (
                  <div className="flex gap-4 sm:gap-5 flex-wrap">
                    <RadioButton
                      id="Dealership"
                      name="purchaseFrom"
                      value="Dealer ship"
                      label="Dealership"
                      checked={value === "Dealer ship"}
                      onChange={onChange}
                    />
                    <RadioButton
                      id="Privatesale"
                      name="purchaseFrom"
                      value="Private sale"
                      label="Private sale"
                      checked={value === "Private sale"}
                      onChange={onChange}
                    />
                    <RadioButton
                      id="Refinance"
                      name="purchaseFrom"
                      value="Refinance"
                      label="Refinance"
                      checked={value === "Refinance"}
                      onChange={onChange}
                    />
                  </div>
                )}
              />
            </div>
            {errors.purchaseFrom && (
              <ErrorsMessage title={errors.purchaseFrom.message} />
            )}
          </div>{" "}
          <div className="text-left mb-12">
            <h6 className="font-Mulish text-nowrap text-base text-lightBlue mb-4">
              What is the condition of the vehicle?
            </h6>
            <div className="flex gap-5">
              <Controller
                name="vehicleCondition"
                control={control}
                rules={{ required: "Please select an option" }}
                render={({ field: { value, onChange } }) => (
                  <div className="flex gap-5 flex-wrap">
                    <RadioButton
                      id="used"
                      name="vehicleCondition"
                      value="used"
                      label="Used"
                      checked={value === "used"}
                      onChange={onChange}
                    />
                    <RadioButton
                      id="new"
                      name="vehicleCondition"
                      value="new"
                      label="New"
                      checked={value === "new"}
                      onChange={onChange}
                    />
                    <RadioButton
                      id="demo"
                      name="vehicleCondition"
                      value="demo"
                      label="Demo"
                      checked={value === "demo"}
                      onChange={onChange}
                    />
                  </div>
                )}
              />
            </div>
            {errors.vehicleCondition && (
              <ErrorsMessage title={errors.vehicleCondition.message} />
            )}
          </div>
          <div className="flex justify-between">
            <PreviousButtom onClick={() => dispatch(prevStep())}>
              Previous
            </PreviousButtom>
            <ContinueButton type="submit">Next</ContinueButton>
          </div>
        </form>
      </div>
    </>
  );
};

export default ConditionAndPurchase;
